import React from 'react'
import Helmet from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'
import ogImage from '../../static/og_image_community.webp'

const SEO = ({ title, description, short_description, path, type, locale, date, tags, author, changeTime, author_link, available_languages }) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          siteUrl
        }
      }
    }
  `)

  const isArticle = type === 'article'
  const siteDescription = (description || short_description) || data.site.siteMetadata.description
  const hrefLang = () => {
    let href
    if (isArticle) {
      if (path.split('/').length > 3) {
        href = data.site.siteMetadata.siteUrl + path.slice(0, path.lastIndexOf('/')) + '/'
      } else {
        href = data.site.siteMetadata.siteUrl + path + '/'
      }
    } else {
      if (path) {
        href = data.site.siteMetadata.siteUrl + '/' + path + '/'
      } else {
        href = data.site.siteMetadata.siteUrl + '/'
      }
    }

    return href
  }

  return (
    <Helmet htmlAttributes={{ lang: `en` }} titleTemplate={`%s | ${ data.site.siteMetadata.title }`}>
      <title>{title}</title>
      <meta name='description' content={ siteDescription }/>
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={siteDescription} />
      <meta name="twitter:url" content={hrefLang()} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image" content={data.site.siteMetadata.siteUrl + ogImage} />
      <meta property="og:image" content={data.site.siteMetadata.siteUrl + ogImage} />
      <meta property="og:image:width" content="1200"/>
      <meta property="og:image:height" content="628"/>
      <meta property="og:title" content={title} />
      <meta property="og:description" content={siteDescription} />
      <meta property="og:url" content={hrefLang()} />
      <meta property="og:type" content={type} />
      <meta property="og:locale" content={locale} />
      {
        isArticle && (
          <meta property="article:pusblished_time" content={date} />
        )
      }
      {
        isArticle && (
          <script type='application/ld+json'>
            {
              JSON.stringify(
                {
                  '@context': 'http://schema.org',
                  '@type': 'Article',
                  'headline': title,
                  'description': siteDescription,
                  'url': data.site.siteMetadata.siteUrl + path + '/' || data.site.siteMetadata.siteUrl + '/',
                  'datePublished': date,
                  'keywords': tags.join(','),
                  'inLanguage': locale,
                  'accessModeSufficient': 'textual',
                  'isAccessibleForFree': true,
                  'license': 'https://github.com/hetzneronline/community-content/blob/fb32f8cd2ead3b7ccc26183203913f7e83d9f8ab/LICENSE',
                  'publishingPrinciples': 'https://github.com/hetzneronline/community-content/blob/fb32f8cd2ead3b7ccc26183203913f7e83d9f8ab/contributing.md',
                  'sourceOrganization': [{
                    '@type': 'Organization',
                    'name': 'Hetzner Community',
                    'url': 'https://community.hetzner.com/'
                  }],
                  'author': [{
                    '@type': 'Person',
                    'name': author,
                    'url': author_link
                  }]
                }
              )
            }
          </script>
        )
      }
      <link rel="canonical" href={ hrefLang() } />
      <link rel="alternate" hreflang={'x-default'} href={hrefLang()} />
      {
        available_languages && available_languages.length > 1 && available_languages.map(language => {
          if (language !== 'en') {
            return (
              <link rel="alternate" hreflang={language} href={hrefLang() + language + '/'} />
            )
          } else {
            return (
              <link rel="alternate" hreflang={language} href={hrefLang()} />
            )
          }
        })
      }

    </Helmet>
  )
}
export default SEO
